export default __webpack_public_path__ + "static/media/photoshop.db6f2a7d.png";